/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-12 11:58:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-29 17:09:17
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Collapse/util.tsx
 */

import React from 'react';

import { mapRightAnchorName } from '@/src/tools/helper';

export const withDraggableId = (Component) => {
  return (props) => {
    const { id } = props;
    return id ? (
      <div id={mapRightAnchorName(id)}>
        <Component {...props}></Component>
      </div>
    ) : (
      <Component {...props}></Component>
    );
  };
};
